(function () {
  const BTN = 'a.arboreal-wa-button';

  function getProductData() {
    const s = document.querySelector('script[type="application/json"][data-product-json]');
    if (!s?.textContent) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function getTitle() {
    const p = getProductData();
    if (p?.title) return String(p.title).trim();
    const h1 = document.querySelector("h1");
    if (h1?.textContent?.trim()) return h1.textContent.trim();
    return "Produto";
  }

  function getVariantId() {
    // 1) URL (quando o tema atualiza)
    const v = new URLSearchParams(window.location.search).get("variant");
    if (v) return String(v);

    // 2) input hidden (quando existe)
    const inputId = document.querySelector('input[name="id"]')?.value;
    if (inputId) return String(inputId);

    // 3) JSON do produto (variant inicial)
    const p = getProductData();
    if (p?.selected_or_first_available_variant?.id) return String(p.selected_or_first_available_variant.id);

    // 4) fallback final
    if (Array.isArray(p?.variants) && p.variants[0]?.id) return String(p.variants[0].id);

    return null;
  }

  function getSelectionsFromVariant(variantId) {
    const product = getProductData();
    if (!product || !variantId) return [];

    const v = (product.variants || []).find(x => String(x.id) === String(variantId));
    if (!v) return [];

    const optionNames = product.options || [];
    const chosen = v.options || [v.option1, v.option2, v.option3].filter(Boolean);

    return chosen
    .filter(val => val && val.toLowerCase() !== 'default title')
    .map((val, i) => `${optionNames[i] || `Opção ${i + 1}`}: ${val}`);

  }

  function buildUrl(a, variantId) {
    const phone = a.getAttribute("data-wa-phone") || "5519999982768";
    const title = getTitle();
    const selections = getSelectionsFromVariant(variantId);

    const msg = selections.length
      ? `Olá! Gostaria de um orçamento para: ${title} | ${selections.join(" | ")}`
      : `Olá! Gostaria de um orçamento para: ${title}`;

    return `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
  }

  // Espera o ?variant= estabilizar (ou mudar) antes de abrir o WhatsApp
  function waitForVariantChange(prevVariant, timeoutMs = 400) {
    return new Promise(resolve => {
      const start = Date.now();
      (function tick() {
        const current = getVariantId();

        // se já tenho um id válido, posso seguir
        if (current) return resolve(current);

        if (Date.now() - start >= timeoutMs) return resolve(prevVariant);
        requestAnimationFrame(tick);
      })();
    });
  }

  async function intercept(e) {
    const a = e.target.closest(BTN);
    if (!a) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // ✅ pega o ID inicial (funciona mesmo sem mexer em variante)
    const before = getVariantId();

    // ✅ se já tenho um variantId, uso ele direto (não espero “mudar”)
    // ✅ se por algum motivo ainda não tiver, espero um pouco
    const finalVariant = before || await waitForVariantChange(before, 400);

    window.location.assign(buildUrl(a, finalVariant));
  }

  // captura cedo pra evitar o tema “reagir”
  document.addEventListener("pointerdown", intercept, true);
  document.addEventListener("touchstart", intercept, true);
  document.addEventListener("click", intercept, true);
})();
